// extracted by mini-css-extract-plugin
export default {"list":"List_list__469Om","header":"List_header__kEEi1","row":"List_row__mQC5n","cell":"List_cell__k52sL","space":"List_space__37hpA"};